import { Controller } from "@hotwired/stimulus"
import { get } from '@rails/request.js'
import { Calendar } from "@fullcalendar/core"
import momentTimezonePlugin from '@fullcalendar/moment-timezone'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import listPlugin from "@fullcalendar/list"
import bootstrap5Plugin from '@fullcalendar/bootstrap5'
import interactionPlugin from '@fullcalendar/interaction';

// Connects to data-controller="calendar"
export default class extends Controller {
	static values = {
		timeZone: { type: String, default: 'local' },
		eventUrl: String
	}

	connect() {
		this.initializeCalendar()
	}

	disconnect() {
		this.calendar.destroy
	}

	initializeCalendar() {
		let _this = this
		this.calendar = new Calendar(this.element, {
			plugins: [momentTimezonePlugin, dayGridPlugin, timeGridPlugin, listPlugin, bootstrap5Plugin, interactionPlugin],
			timeZone: this.timeZoneValue,
			eventColor: '#ffffff',
			eventTextColor: '#555555',
			firstDay: 1,
			events: this.eventUrlValue,
			slotDuration: { days: 1 },
			weekends: false,
			fixedWeekCount: false,
			contentHeight: 300,
			allDaySlot: true,
			editable: false,
			eventDurationEditable: false,
			navLinks: true,
			nowIndicator: false,
			themeSystem: 'bootstrap5',
			initialView: 'dayGridMonth',
			headerToolbar: {
				left: 'prev,next',
				center: 'title',
				right: 'dayGridMonth,today'
			},
			buttonIcons: {
				prev: 'chevron-compact-left',
				next: 'chevron-compact-right',
				dayGridMonth: 'calendar-month',
			},
			dateClick: function (info) {
				let params = new URLSearchParams()
				params.append("report_date", info.dateStr)
				get(`/calendars/reports?${params}`, {
					responseKind: "turbo-stream"
				})
				info.dayEl.style.backgroundColor = '#09B850';
				setTimeout(() => {
					info.dayEl.style.backgroundColor = '#ffffff';
				}, 1000)
			}
		})
		this.calendar.render()
	}
}